import { memo } from 'react';
import type { ReactNode } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { IconDownLoad02 } from '@wconcept/wconcept-ui-renewal/src/components/atoms/svg';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
}

type ColorType = 'black' | 'gray' | CustomColorType | string;

interface IProps {
  colorType?: ColorType;
  title?: string;
  desc?: ReactNode;
  count?: number;
  status?: 'download' | 'comingsoon' | 'end' | 'soldout' | string;
  onClick?: () => void;
}

const CouponItem2 = ({
  colorType = 'black',
  title,
  desc,
  count,
  status = 'download',
  onClick,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'coupon-item item',
    !isCustomColor ? `bg-type-${colorType}` : '',
    status !== 'download' ? 'disabled' : '',
  ]);

  return (
    <S.CouponItem2
      className={cName}
      $bgColor={customColors?.bgColor}
      $pointColor={customColors?.pointColor}
      $emphasisTextColor={customColors?.emphasisTextColor}
    >
      <div className="text-wrap">
        {title && <Text className="title">{title}</Text>}
        {desc && <Text className="desc">{desc}</Text>}
      </div>
      <Button onClick={onClick} disabled={status !== 'download'}>
        <IconDownLoad02 />
        {(count as number) > 0 && (
          <Text size={11} lineHeight={14} block>
            {(count as number) >= 100
              ? '<em>99+</em>장'
              : `<em>${count}</em>장`}
          </Text>
        )}
      </Button>
    </S.CouponItem2>
  );
};

export default memo(CouponItem2);
